/**
 * En mode édition CMS (ContentBuilder), empêche les liens simples du carrousel
 * produits (ex: "Tout voir") de quitter l'éditeur au clic.
 *
 * On se contente d'un preventDefault SANS stopper la propagation : l'événement
 * doit continuer de remonter pour que ContentBuilder puisse sélectionner le bloc.
 * Les cartes produits (a.fire-event) ne sont pas gérées ici : ProductEvent fait
 * déjà le preventDefault et n'enclenche pas la redirection en mode édition.
 *
 * Le garde ne s'arme que si le marqueur de mode édition (#edit-mode) est présent.
 */
export default function initCarouselEditGuard() {
    if (!document.getElementById('edit-mode')) {
        return;
    }

    document.addEventListener('click', (e) => {
        const link = e.target.closest('.product-carousel-cms a, .link-view-all');

        if (link && !link.classList.contains('fire-event')) {
            e.preventDefault();
        }
    }, true);
}
